import { PropsWithChildren, useEffect } from 'react';

import { useRouter } from '@tanstack/react-router';

import { usePageTitle } from '@/app/hooks/usePageTitle';
import { HitType } from '@/app/libs/analytics/enum/HitType';
import { Analytics } from '@/app/libs/analytics/instance';
import { Clarity } from '@/app/libs/clarity/instance';
import { getPageId } from '@/app/libs/clarity/utils/get-page-id';

export const AnalyticsProvider = ({ children }: PropsWithChildren) => {
  const router = useRouter();
  const title = usePageTitle();

  useEffect(() => {
    const unsubscribe = router.history.subscribe(() => {
      const { pathname, search } = router.history.location;
      const page = pathname + search;

      Analytics.send({ page, title, hitType: HitType.PAGE_VIEW, sessionControl: 'start' });

      if (!title) return;

      const pageId = getPageId(title);

      if (!pageId) return;

      Clarity.setTag('pageId', pageId);
      Clarity.upgrade('page has been changed by user navigation');
    });

    return unsubscribe;
  }, [title, router.history]);

  return <>{children}</>;
};
